var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Reports")]),_c('v-container',{staticClass:"main-section-reports ma-1 pa-1",attrs:{"fluid":""}},[_c('ReportsList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }